module.exports = __webpack_public_path__ + "media/fail(1).e827d5d3.wav";